import { offsetFunction } from './customFunctions';
// const Forms = () => {
//   const hubspotForm = document.querySelectorAll('.hbspt-form form.hs-custom-style');

//   //Remove hubspot's styling from forms
//   if (hubspotForm) {
//     hubspotForm.forEach(function(form) {
//       form.classList.remove('hs-custom-style');
//     });
//   }
// };

const $ = jQuery.noConflict();

const forms = () => {
	// Apply select2 plugin to gform select fields
	const singleSelect = $('.gform_wrapper').find(
		'select:not([multiple]):not([class*=select2])'
	);
	const multiSelect = $('.gform_wrapper').find(
		'select[multiple]:not([class*=select2])'
	);

	if (singleSelect.length) {
		singleSelect.each((i, select) => {
			const selectSingle = $(select);
			const gfPlaceholder = selectSingle.children('.gf_placeholder');
			const ariaLabel = selectSingle.attr('aria-label');
			let placeholderText = 'Select item';

			if (gfPlaceholder.length) {
				placeholderText = gfPlaceholder.text();
			} else if (ariaLabel) {
				placeholderText = ariaLabel;
			}

			selectSingle.select2({
				minimumResultsForSearch: Infinity,
				placeholder: placeholderText,
				width: '100%',
			});

			selectSingle.on('select2:close', () => {
				$('.select2-selection--single').blur();
			});

			$(window).on('resize', () => {
				selectSingle.select2('close');
			});
		});
	}

	if (multiSelect.length) {
		multiSelect.each((i, select) => {
			const selectSingle = $(select);
			const placeholderText = 'Select item';

			selectSingle.select2MultiCheckboxes({
				minimumResultsForSearch: Infinity,
				placeholder: placeholderText,
				width: '100%',
				templateSelection(selected) {
					/* eslint-disable */
					return selected.length ? ( typeof selected === 'object' ? selected.join( ', ' ) : selected ) : placeholderText;
					/* eslint-enable */
				},
			});

			selectSingle.on('select2:close', () => {
				$('.select2-selection--single').blur();
			});

			$(window).on('resize', () => {
				selectSingle.select2('close');
			});
		});
	}

	// GF datepicker preinit settings
	/* eslint-disable */
	gform.addFilter( 'gform_datepicker_options_pre_init', ( optionsObj ) => {
		/* eslint-enable */
		optionsObj.firstDay = 1;
		optionsObj.changeMonth = true;
		optionsObj.changeYear = true;

		return optionsObj;
	});
};

const formScrollTop = () => {
	const header = document.querySelector('.main-header');
	let headerHeight = 0;
	if (header) {
		headerHeight = header.getBoundingClientRect().height;
	}
	const alertBar = document.querySelector('.alert-bar');
	let alertBarHeight = 0;
	if (alertBar) {
		alertBarHeight = alertBar.getBoundingClientRect().height;
	}
	const anchors = document.querySelectorAll('.gform_anchor');
	const offset = headerHeight + alertBarHeight + 50;

	[...anchors].forEach((anchor) => {
		if (
			anchor.parentNode.classList.contains('gform_validation_error') ||
			anchor.nextElementSibling.classList.contains(
				'gform_confirmation_wrapper '
			)
		) {
			$('html, body')
				.stop()
				.animate(
					{
						scrollTop: parseInt(
							offsetFunction(anchor).top - offset,
							10
						),
					},
					50
				);
		}
	});
};

export { forms, formScrollTop };
